export const rangeType = [
  { value: 'all', label: '全部' },
  { value: 'before', label: '前' },
  { value: 'after', label: '后' },
  { value: 'staticList', label: '固定' },
  { value: 'keyword', label: '关键字' },
  { value: 'fixedColumn', label: '固定文章列' }
  // { value: 'asc', label: '顺序' },
  // { value: 'desc', label: '倒序' }
]
export const extractType = [
  { value: '0', label: '全部' },
  { value: '1', label: '中文' },
  { value: '2', label: '英文' },
  { value: '3', label: '数字' },
  { value: '4', label: '年' },
  { value: '5', label: '年月' },
  { value: '6', label: '年月日' },
  { value: '7', label: '中文+英文' },
  { value: '8', label: '中文+数字' },
  { value: '9', label: '英文+数字' },
  { value: '10', label: '数字+符号' }
]

export const orderBy = [
  { value: '', label: '默认排序' },
  { value: 'updatetime desc', label: '发布时间降序' },
  { value: 'updatetime asc', label: '发布时间升序' },
  { value: 'createtime desc', label: '创建时间降序' },
  { value: 'createtime asc', label: '创建时间升序' },
  { value: 'score', label: '相关度排序' },
  { value: 'rearticlecount desc', label: '转载量排序' },
  { value: 'degree desc', label: '热度降序' },
  { value: 'degree asc', label: '热度升序' },
  { value: 'videosize  asc', label: '正面升序' },
  { value: 'videosize  desc', label: '正面降序' }
]
export const rangeNumType = [
  { value: 'charts', label: '字符' },
  { value: 'section', label: '段落' }
]
export const actives = [
  { value: 0, label: '禁用' },
  { value: 1, label: '启用' }
]
export const sexs = [
  { value: 0, label: '保密' },
  { value: 1, label: '男' },
  { value: 2, label: '女' }
]

export const serviceType = [
  { value: 1, label: '媒体' },
  { value: 2, label: '政府' },
  { value: 3, label: '企业' }
]

export const chartsType = [
  { value: 1, label: '表格' },
  { value: 2, label: '柱状' },
  { value: 3, label: '曲线' },
  { value: 4, label: '饼图' }
]

export const dataType = [
  { value: 0, label: '字符' },
  { value: 1, label: '数字' },
  { value: 2, label: '年份', format: 'yyyy' },
  { value: 3, label: '年月', format: 'yyyy-MM' },
  { value: 4, label: '年月日', format: 'yyyy-MM-dd' },
  { value: 5, label: '月日', format: 'MM-dd' }
]

export const projectFlag = [
  { value: 1, label: '正式' },
  { value: 2, label: '临时' }
]
export const originalType = [
  { value: '', label: '不限' },
  { value: 1, label: '原创' },
  { value: 10, label: '转载' }
]

export const buyType = [
  { value: 1, label: '标准' },
  { value: 2, label: '专业' },
  { value: 3, label: '高级' },
  { value: 4, label: '完整' }
]

export const menuType = [
  { value: 'menu', label: '菜单' },
  { value: 'page', label: '页面' },
  { value: 'button', label: '按钮' },
  { value: 'alert', label: '弹窗' },
  { value: 'systemmenu', label: '模块' },
  { value: 'component', label: '组件' }
]

export const roleType = [
  { value: '', label: '未设置' },
  { value: 0, label: '未设置' },
  { value: 1, label: '系统角色' },
  { value: 2, label: '业务角色' }
]

export const MenuStyle = [
  { value: 'all', label: '全部' },
  { value: 'icon', label: '图标' },
  { value: 'text', label: '文字' }
]

export const fullScreen = [
  { value: 'full', label: '全屏' },
  { value: 'head', label: '头部背景' },
  { value: 'background', label: '背景框' }
]

export const MenuPosition = [
  { value: 'left', label: '左边' },
  { value: 'top', label: '顶部' }
]
export const MenuColor = [
  '#000',
  '#fff',
  '#274c5e',
  '#dae9f4',
  '#78909c',
  '#7f9eb2'
]
export const MenuTextColor = [
  { value: '#000000', label: '黑' },
  { value: '#ffffff', label: '白' }
]
export const MenuActiveColor = [
  { value: '#000000', label: '黑' },
  { value: '#ffffff', label: '白' }
]
export const articleTag = [
  { value: '', label: '全部' },
  { value: '社会', label: '社会' },
  { value: '教育', label: '教育' },
  { value: '时政', label: '时政' },
  { value: '经济', label: '经济' },
  { value: '军事', label: '军事' },
  { value: '科技', label: '科技' },
  { value: '体育', label: '体育' },
  { value: '艺术', label: '艺术' },
  { value: '交通', label: '交通' },
  { value: '娱乐', label: '娱乐' },
  { value: '汽车', label: '汽车' },
  { value: '房产', label: '房产' },
  { value: '天气', label: '天气' },
  { value: '旅游', label: '旅游' },
  { value: '美食', label: '美食' }
]
export const articleType = [
  { value: '', label: '不限' },
  { value: 'news', label: '报纸' },
  { value: 'website', label: '网站' },
  { value: 'weibo', label: '微博' },
  { value: 'weixin', label: '微信' },
  { value: 'webbbs', label: '论坛' },
  { value: 'webapp', label: 'APP' }
]
export const emotionalType = [
  { value: '', label: '不限' },
  { value: 5001, label: '正面' },
  { value: 1, label: '负面' }
]
export const isPotoType = [
  { value: '', label: '不限' },
  { value: 1, label: '包含' },
  { value: 0, label: '不包含' }
]
export const originValue = [
  { value: '', label: '不限制' },
  { value: '1,1', label: '一级原创' },
  { value: '1,9', label: '原创' },
  { value: '10,50', label: '转载' }
]
export const dtlWordType = [
  { value: 0, label: '全部' },
  { value: 901, label: '长效词库' },
  { value: 902, label: '测试词库' }
]
export const channelType = [
  { value: 0, label: '普通栏目' },
  { value: 1, label: '搜索栏目' }
]
export const ifRecommend = [
  { value: 0, label: '否' },
  { value: 1, label: '是' }
]
export const paperCountLists = [
  { value: 0, label: '头条头版' },
  { value: 1, label: '头版' }
]
export const contentRegexPlaceList = [
  { value: 'pEmpty', label: '段落中文空格' },
  { value: 'pIndent', label: '段落样式空格' }
]
export const autoOriginal = [
  { value: 1, label: '早上' },
  { value: 2, label: '中午' },
  { value: 3, label: '晚上' }
]
export const rulesStatus = [
  { value: -1, label: '全部' },
  { value: 0, label: '未审核' },
  { value: 1, label: '已审核' },
  { value: 2, label: '修改审核' },
  { value: 3, label: '驳回' }
]
export const exceptIDList = [
  { value: 341, label: '广告' },
  { value: 342, label: '无标题' },
  { value: 343, label: '相似未计算' },
  { value: 346, label: '标题无中文' },
  { value: 350, label: '采用正文相似度过滤重复' },
  { value: 352, label: '整个客户(applicationID)过滤重复' }
]
export const contentRegexPlaceRule = [
  { value: '', label: '原始格式', tip: '' },
  { value: 'replace_p', label: '纯净阅读', tip: '通用规则去除所有原有格式' },
  { value: 'replace_p|table', label: '转换段落', tip: '通用规则，并且转换table中的每行为一个段落' },
  { value: 'replace_p|table_alldel', label: '移除表格', tip: '通用规则，并且去除标签table之间的所有内容' }
]
export const articleTypeList = [
  { label: '选择下面明细', value: '' },
  { label: '全网数据', value: 'all' },
  { label: '全部网站微信微博', value: 'webindexall' },
  { label: '全部报纸', value: 'news' },
  { label: '全部微博', value: 'weiboall' },
  { label: '全部网站（网站、论坛、客户端）', value: 'websiteall' },
  { label: '全部微信', value: 'weixinall' }
]

export const ddlifLocal = [
  { value: -1, label: '全部城市' },
  { value: 0, label: '无城市' },
  { value: 259, label: '阿坝藏族羌族自治州' },
  { value: 338, label: '阿克苏地区' },
  { value: 38, label: '阿拉善盟' },
  { value: 344, label: '阿勒泰地区' },
  { value: 292, label: '阿里地区' },
  { value: 302, label: '安康市' },
  { value: 108, label: '安庆市' },
  { value: 265, label: '安顺市' },
  { value: 159, label: '安阳市' },
  { value: 41, label: '鞍山市' },
  { value: 347, label: '澳门' },
  { value: 34, label: '巴彦淖尔市' },
  { value: 337, label: '巴音郭楞蒙古自治州' },
  { value: 257, label: '巴中市' },
  { value: 60, label: '白城市' },
  { value: 58, label: '白山市' },
  { value: 307, label: '白银市' },
  { value: 230, label: '百色市' },
  { value: 103, label: '蚌埠市' },
  { value: 28, label: '包头市' },
  { value: 296, label: '宝鸡市' },
  { value: 10, label: '保定市' },
  { value: 274, label: '保山市' },
  { value: 225, label: '北海市' },
  { value: 1, label: '北京' },
  { value: 43, label: '本溪市' },
  { value: 268, label: '毕节地区' },
  { value: 153, label: '滨州市' },
  { value: 115, label: '亳州市' },
  { value: 336, label: '博尔塔拉蒙古自治州' },
  { value: 13, label: '沧州市' },
  { value: 288, label: '昌都地区' },
  { value: 335, label: '昌吉回族自治州' },
  { value: 53, label: '长春市' },
  { value: 186, label: '长沙市' },
  { value: 19, label: '长治市' },
  { value: 192, label: '常德市' },
  { value: 80, label: '常州市' },
  { value: 113, label: '巢湖市' },
  { value: 51, label: '朝阳市' },
  { value: 218, label: '潮州市' },
  { value: 195, label: '郴州市' },
  { value: 241, label: '成都市' },
  { value: 12, label: '承德市' },
  { value: 116, label: '池州市' },
  { value: 30, label: '赤峰市' },
  { value: 234, label: '崇左市' },
  { value: 110, label: '滁州市' },
  { value: 279, label: '楚雄彝族自治州' },
  { value: 255, label: '达州市' },
  { value: 283, label: '大理白族自治州' },
  { value: 40, label: '大连市' },
  { value: 67, label: '大庆市' },
  { value: 17, label: '大同市' },
  { value: 74, label: '大兴安岭地区' },
  { value: 44, label: '丹东市' },
  { value: 284, label: '德宏傣族景颇族自治州' },
  { value: 245, label: '德阳市' },
  { value: 151, label: '德州市' },
  { value: 286, label: '迪庆藏族自治州' },
  { value: 314, label: '定西市' },
  { value: 216, label: '东莞市' },
  { value: 142, label: '东营市' },
  { value: 32, label: '鄂尔多斯市' },
  { value: 177, label: '鄂州市' },
  { value: 184, label: '恩施土家族苗族自治州' },
  { value: 373, label: '二连浩特市' },
  { value: 226, label: '防城港市' },
  { value: 205, label: '佛山市' },
  { value: 118, label: '福州市' },
  { value: 42, label: '抚顺市' },
  { value: 136, label: '抚州市' },
  { value: 47, label: '阜新市' },
  { value: 111, label: '阜阳市' },
  { value: 317, label: '甘南藏族自治州' },
  { value: 260, label: '甘孜藏族自治州' },
  { value: 133, label: '赣州市' },
  { value: 349, label: '高雄' },
  { value: 366, label: '高雄县' },
  { value: 329, label: '固原市' },
  { value: 254, label: '广安市' },
  { value: 247, label: '广元市' },
  { value: 200, label: '广州市' },
  { value: 228, label: '贵港市' },
  { value: 262, label: '贵阳市' },
  { value: 223, label: '桂林市' },
  { value: 323, label: '果洛藏族自治州' },
  { value: 62, label: '哈尔滨市' },
  { value: 334, label: '哈密地区' },
  { value: 320, label: '海北藏族自治州' },
  { value: 319, label: '海东地区' },
  { value: 235, label: '海口市' },
  { value: 322, label: '海南藏族自治州' },
  { value: 372, label: '海外' },
  { value: 325, label: '海西蒙古族藏族自治州' },
  { value: 8, label: '邯郸市' },
  { value: 300, label: '汉中市' },
  { value: 90, label: '杭州市' },
  { value: 101, label: '合肥市' },
  { value: 341, label: '和田地区' },
  { value: 232, label: '河池市' },
  { value: 213, label: '河源市' },
  { value: 154, label: '荷泽市' },
  { value: 231, label: '贺州市' },
  { value: 160, label: '鹤壁市' },
  { value: 65, label: '鹤岗市' },
  { value: 72, label: '黑河市' },
  { value: 15, label: '衡水市' },
  { value: 189, label: '衡阳市' },
  { value: 280, label: '红河哈尼族彝族自治州' },
  { value: 27, label: '呼和浩特市' },
  { value: 33, label: '呼伦贝尔市' },
  { value: 94, label: '湖州市' },
  { value: 52, label: '葫芦岛市' },
  { value: 369, label: '花莲县' },
  { value: 197, label: '怀化市' },
  { value: 84, label: '淮安市' },
  { value: 106, label: '淮北市' },
  { value: 104, label: '淮南市' },
  { value: 181, label: '黄冈市' },
  { value: 321, label: '黄南藏族自治州' },
  { value: 109, label: '黄山市' },
  { value: 173, label: '黄石市' },
  { value: 210, label: '惠州市' },
  { value: 64, label: '鸡西市' },
  { value: 350, label: '基隆' },
  { value: 134, label: '吉安市' },
  { value: 54, label: '吉林市' },
  { value: 138, label: '济南市' },
  { value: 145, label: '济宁市' },
  { value: 371, label: '济源市' },
  { value: 69, label: '佳木斯市' },
  { value: 93, label: '嘉兴市' },
  { value: 354, label: '嘉义' },
  { value: 364, label: '嘉义县' },
  { value: 305, label: '嘉峪关市' },
  { value: 206, label: '江门市' },
  { value: 162, label: '焦作市' },
  { value: 219, label: '揭阳市' },
  { value: 306, label: '金昌市' },
  { value: 96, label: '金华市' },
  { value: 45, label: '锦州市' },
  { value: 20, label: '晋城市' },
  { value: 22, label: '晋中市' },
  { value: 178, label: '荆门市' },
  { value: 180, label: '荆州市' },
  { value: 128, label: '景德镇市' },
  { value: 130, label: '九江市' },
  { value: 312, label: '酒泉市' },
  { value: 340, label: '喀什地区' },
  { value: 156, label: '开封市' },
  { value: 332, label: '克拉玛依市' },
  { value: 339, label: '克孜勒苏柯尔克孜自治州' },
  { value: 271, label: '昆明市' },
  { value: 287, label: '拉萨市' },
  { value: 233, label: '来宾市' },
  { value: 149, label: '莱芜市' },
  { value: 304, label: '兰州市' },
  { value: 14, label: '廊坊市' },
  { value: 250, label: '乐山市' },
  { value: 276, label: '丽江市' },
  { value: 100, label: '丽水市' },
  { value: 83, label: '连云港市' },
  { value: 261, label: '凉山彝族自治州' },
  { value: 48, label: '辽阳市' },
  { value: 56, label: '辽源市' },
  { value: 152, label: '聊城市' },
  { value: 293, label: '林芝地区' },
  { value: 278, label: '临沧市' },
  { value: 25, label: '临汾市' },
  { value: 316, label: '临夏回族自治州' },
  { value: 150, label: '临沂市' },
  { value: 222, label: '柳州市' },
  { value: 114, label: '六安市' },
  { value: 263, label: '六盘水市' },
  { value: 125, label: '龙岩市' },
  { value: 315, label: '陇南市' },
  { value: 198, label: '娄底市' },
  { value: 244, label: '泸州市' },
  { value: 26, label: '吕梁市' },
  { value: 157, label: '洛阳市' },
  { value: 165, label: '漯河市' },
  { value: 105, label: '马鞍山市' },
  { value: 374, label: '满洲里市' },
  { value: 208, label: '茂名市' },
  { value: 252, label: '眉山市' },
  { value: 211, label: '梅州市' },
  { value: 246, label: '绵阳市' },
  { value: 359, label: '苗栗县' },
  { value: 71, label: '牡丹江市' },
  { value: 249, label: '内江市' },
  { value: 291, label: '那曲地区' },
  { value: 127, label: '南昌市' },
  { value: 251, label: '南充市' },
  { value: 77, label: '南京市' },
  { value: 221, label: '南宁市' },
  { value: 124, label: '南平市' },
  { value: 82, label: '南通市' },
  { value: 362, label: '南投县' },
  { value: 167, label: '南阳市' },
  { value: 91, label: '宁波市' },
  { value: 126, label: '宁德市' },
  { value: 285, label: '怒江傈僳族自治州' },
  { value: 243, label: '攀枝花市' },
  { value: 49, label: '盘锦市' },
  { value: 370, label: '澎湖县' },
  { value: 158, label: '平顶山市' },
  { value: 311, label: '平凉市' },
  { value: 367, label: '屏东县' },
  { value: 129, label: '萍乡市' },
  { value: 120, label: '莆田市' },
  { value: 163, label: '濮阳市' },
  { value: 70, label: '七台河市' },
  { value: 63, label: '齐齐哈尔市' },
  { value: 269, label: '黔东南苗族侗族自治州' },
  { value: 270, label: '黔南布依族苗族自治州' },
  { value: 267, label: '黔西南布依族苗族自治州' },
  { value: 227, label: '钦州市' },
  { value: 7, label: '秦皇岛市' },
  { value: 139, label: '青岛市' },
  { value: 215, label: '清远市' },
  { value: 313, label: '庆阳市' },
  { value: 272, label: '曲靖市' },
  { value: 97, label: '衢州市' },
  { value: 122, label: '泉州市' },
  { value: 290, label: '日喀则地区' },
  { value: 148, label: '日照市' },
  { value: 166, label: '三门峡市' },
  { value: 121, label: '三明市' },
  { value: 236, label: '三亚市' },
  { value: 289, label: '山南地区' },
  { value: 204, label: '汕头市' },
  { value: 212, label: '汕尾市' },
  { value: 303, label: '商洛市' },
  { value: 168, label: '商丘市' },
  { value: 75, label: '上海' },
  { value: 137, label: '上饶市' },
  { value: 201, label: '韶关市' },
  { value: 190, label: '邵阳市' },
  { value: 95, label: '绍兴市' },
  { value: 202, label: '深圳市' },
  { value: 39, label: '沈阳市' },
  { value: 237, label: '省直辖县级行政单位' },
  { value: 185, label: '省直辖行政单位' },
  { value: 345, label: '省直辖行政单位' },
  { value: 174, label: '十堰市' },
  { value: 5, label: '石家庄市' },
  { value: 327, label: '石嘴山市' },
  { value: 66, label: '双鸭山市' },
  { value: 21, label: '朔州市' },
  { value: 277, label: '思茅市' },
  { value: 55, label: '四平市' },
  { value: 59, label: '松原市' },
  { value: 81, label: '苏州市' },
  { value: 89, label: '宿迁市' },
  { value: 112, label: '宿州市' },
  { value: 73, label: '绥化市' },
  { value: 183, label: '随州市' },
  { value: 248, label: '遂宁市' },
  { value: 343, label: '塔城地区' },
  { value: 348, label: '台北' },
  { value: 355, label: '台北县' },
  { value: 368, label: '台东县' },
  { value: 352, label: '台南' },
  { value: 365, label: '台南县' },
  { value: 351, label: '台中' },
  { value: 360, label: '台中县' },
  { value: 99, label: '台州市' },
  { value: 16, label: '太原市' },
  { value: 146, label: '泰安市' },
  { value: 88, label: '泰州市' },
  { value: 6, label: '唐山市' },
  { value: 357, label: '桃园县' },
  { value: 3, label: '天津' },
  { value: 308, label: '天水市' },
  { value: 50, label: '铁岭市' },
  { value: 57, label: '通化市' },
  { value: 31, label: '通辽市' },
  { value: 295, label: '铜川市' },
  { value: 107, label: '铜陵市' },
  { value: 266, label: '铜仁地区' },
  { value: 333, label: '吐鲁番地区' },
  { value: 147, label: '威海市' },
  { value: 144, label: '潍坊市' },
  { value: 298, label: '渭南市' },
  { value: 92, label: '温州市' },
  { value: 281, label: '文山壮族苗族自治州' },
  { value: 29, label: '乌海市' },
  { value: 35, label: '乌兰察布市' },
  { value: 331, label: '乌鲁木齐市' },
  { value: 78, label: '无锡市' },
  { value: 328, label: '吴忠市' },
  { value: 102, label: '芜湖市' },
  { value: 224, label: '梧州市' },
  { value: 172, label: '武汉市' },
  { value: 309, label: '武威市' },
  { value: 294, label: '西安市' },
  { value: 318, label: '西宁市' },
  { value: 282, label: '西双版纳傣族自治州' },
  { value: 37, label: '锡林郭勒盟' },
  { value: 119, label: '厦门市' },
  { value: 182, label: '咸宁市' },
  { value: 297, label: '咸阳市' },
  { value: 346, label: '香港' },
  { value: 188, label: '湘潭市' },
  { value: 199, label: '湘西土家族苗族自治州' },
  { value: 176, label: '襄阳市' },
  { value: 179, label: '孝感市' },
  { value: 24, label: '忻州市' },
  { value: 161, label: '新乡市' },
  { value: 131, label: '新余市' },
  { value: 353, label: '新竹' },
  { value: 358, label: '新竹县' },
  { value: 169, label: '信阳市' },
  { value: 36, label: '兴安盟' },
  { value: 9, label: '邢台市' },
  { value: 79, label: '徐州市' },
  { value: 164, label: '许昌市' },
  { value: 117, label: '宣城市' },
  { value: 256, label: '雅安市' },
  { value: 143, label: '烟台市' },
  { value: 299, label: '延安市' },
  { value: 61, label: '延边朝鲜族自治州' },
  { value: 85, label: '盐城市' },
  { value: 86, label: '扬州市' },
  { value: 214, label: '阳江市' },
  { value: 18, label: '阳泉市' },
  { value: 68, label: '伊春市' },
  { value: 342, label: '伊犁哈萨克自治州' },
  { value: 253, label: '宜宾市' },
  { value: 175, label: '宜昌市' },
  { value: 135, label: '宜春市' },
  { value: 356, label: '宜兰县' },
  { value: 194, label: '益阳市' },
  { value: 326, label: '银川市' },
  { value: 132, label: '鹰潭市' },
  { value: 46, label: '营口市' },
  { value: 196, label: '永州市' },
  { value: 301, label: '榆林市' },
  { value: 229, label: '玉林市' },
  { value: 324, label: '玉树藏族自治州' },
  { value: 273, label: '玉溪市' },
  { value: 191, label: '岳阳市' },
  { value: 220, label: '云浮市' },
  { value: 363, label: '云林县' },
  { value: 23, label: '运城市' },
  { value: 141, label: '枣庄市' },
  { value: 207, label: '湛江市' },
  { value: 193, label: '张家界市' },
  { value: 11, label: '张家口市' },
  { value: 310, label: '张掖市' },
  { value: 361, label: '彰化县' },
  { value: 123, label: '漳州市' },
  { value: 275, label: '昭通市' },
  { value: 209, label: '肇庆市' },
  { value: 87, label: '镇江市' },
  { value: 155, label: '郑州市' },
  { value: 217, label: '中山市' },
  { value: 330, label: '中卫市' },
  { value: 238, label: '重庆' },
  { value: 98, label: '舟山市' },
  { value: 170, label: '周口市' },
  { value: 187, label: '株洲市' },
  { value: 203, label: '珠海市' },
  { value: 171, label: '驻马店市' },
  { value: 258, label: '资阳市' },
  { value: 140, label: '淄博市' },
  { value: 242, label: '自贡市' },
  { value: 264, label: '遵义市' }]
